import {FC} from 'react'
import {useHistory} from 'react-router-dom'
import {useDispatch} from 'react-redux'
import {TitleContainer} from 'components/layout/TitleContainer'
import {MainTitle} from 'components/ui/MainTitle'
import {generateDynamicPath, MYPAGE_PATHS} from 'consts/paths'
import {useStartProcedureStatus} from 'features/procedures/hooks/useStartProcedureStatus'
import {Container, StartProcedureCard} from 'features/procedures/StartProcedureCard'
import {useSelector} from 'hooks/redux'
import {asyncError} from 'store/actions/asyncError'

export const Index: FC = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const currentEmployee = useSelector((state) => state.session.currentUser.employee)
  const [startProcedureStatus] = useStartProcedureStatus()

  if (!currentEmployee) {
    return null
  }

  const handleStartChildcare = (procedureType: string, nextPath: string) => async () => {
    try {
      const res = await startProcedureStatus({
        variables: {
          input: {
            employeeId: `${currentEmployee.id}`,
            procedureType,
            status: 'employee_draft',
            initialized: false,
          },
        },
      })
      const id = res.data?.startProcedureStatus.procedureStatus.id
      if (id) {
        history.push(generateDynamicPath(nextPath, [{pattern: 'id', replacement: id}]))
      }
    } catch (err) {
      dispatch(asyncError(err))
    }
  }

  return (
    <div>
      <TitleContainer subPage>
        <MainTitle>育休の手続きを選択</MainTitle>
      </TitleContainer>
      <Container>
        <StartProcedureCard
          onClick={handleStartChildcare('start_childcare', MYPAGE_PATHS.PROCEDURES.START_CHILDCARE.FLOW)}
          variant="start"
        >
          育休の開始
        </StartProcedureCard>
        <StartProcedureCard
          onClick={handleStartChildcare('extend_childcare', MYPAGE_PATHS.PROCEDURES.EXTEND_CHILDCARE.FLOW)}
          variant="start"
        >
          育休の延長
        </StartProcedureCard>
        <StartProcedureCard
          onClick={handleStartChildcare('finish_childcare', MYPAGE_PATHS.PROCEDURES.FINISH_CHILDCARE.FLOW)}
          variant="start"
        >
          育休の終了
        </StartProcedureCard>
      </Container>
    </div>
  )
}
